import type { FieldName } from './FieldName'
import { fieldNameKey } from './fieldNameKey'

export const isFieldName = (value: string): value is FieldName => Object.hasOwn(fieldNameKey, value)
